import { isImageUrl } from "@/utils/urlUtils";
import React from "react";
import RegularVideoCard from "./RegularVideoCard";
import SingleImageWithFallback from "./SingleImageWithFallback";
import FacebookMediaCarousel from "./SocialMediaCarousel";
import TemplateVideoPreviewCard from "./TemplateVideoPreviewCard";

interface MediaSectionProps {
  mediaUrls: string[];
  isTemplateVideo?: boolean;
}

const MediaSection: React.FC<MediaSectionProps> = ({
  mediaUrls,
  isTemplateVideo,
}) => {
  if (mediaUrls.length === 0) return null;

  if (mediaUrls.length === 1) {
    const url = mediaUrls[0];
    if (!isImageUrl(url)) {
      return <RegularVideoCard url={url} />;
    } else if (isTemplateVideo) {
      return <TemplateVideoPreviewCard url={url} />;
    } else {
      return <SingleImageWithFallback url={url} />;
    }
  }

  return <FacebookMediaCarousel mediaUrls={mediaUrls} />;
};

export default MediaSection;
